import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class ChatsAccessRight {
  public static VIEW_CHATS_LIST: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel <= 2;
}
